import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { Language, LoginUserData, PostDetailContext } from "../../App";
import { _imagesURL, GetCommentsApi, GetRepliesApi, DeletePostApi, EditPostApi, adminBaseURL, FollowApi } from "../../constants/API";
import ImageComponent from "./ImageComponent";
import ProfileAvatar from "./ProfileAvatar";
import { BsThreeDots } from "react-icons/bs";
import PostMediaGallery from "../feeds/cards/PostMediaGallery";
import LikeUsersModal from "../../pages/LikeUsersModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { likePostApi, reactToPostApi, repostPostApi, reserveWebinarApi, savePostApi, usersLikedPostApi } from "../../services/feedApis";
import { useMutation, useQuery, useQueryClient } from "react-query";
import InfiniteScroll from "react-infinite-scroller";
import { PROFILE } from "../../constants/RoutesUrl";
import RepostUserModal from "../feeds/modals/RepostUserModal";
import WebinarInvited from "../webinar/WebinarInvited";
import ClinicalPoll from "../clinical-sessions/ClinicalPoll";
import { GoClock, GoScreenFull } from "react-icons/go";
import { IoCalendarOutline, IoCloseSharp, IoThumbsUpOutline, IoThumbsUp, IoChatbubbleOutline, IoBookmarkOutline, IoBookmark } from "react-icons/io5";
import { AiOutlineRetweet } from "react-icons/ai";
import { ReadMore } from "./ReadMore";
import CommentList from "../comments/CommentList";
import AddComment from "../comments/AddComment";
import { authorize } from "../../shared/authorize";
import axios from "axios";
import PostHeaderDropdown from "../feeds/cards/PostHeaderDropdown";
import ShareModal from "../feeds/modals/ShareModal";
import InviteWebinarPopup from "../feeds/postTabs/InviteWebinarPopup";
import PostForm from "../feeds/createPost/PostForm";
import PollOptionsView from "../../pages/PollOptionsView";
import PollResultsView from "../../pages/PollResultsView";
import ReportModal from "../../pages/ReportModal";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";
import { UnixToRelative } from "../notification/Notification";
import useWebinarButtonText from "../../hooks/home/webinar/useWebinarButtonText";
import PostFooter, { calculateTotalReactions } from "../feeds/cards/PostFooter";
import "../feeds/cards/PostFooter.css";

export default function PostDetailModal({ isOpen, onClose, type }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const userData = localStorage.getItem("SignupData");
  const user = userData ? JSON.parse(userData) : null;
  const user_id = user?.data?.id;
  const { postDetail, updatePostDetail, postModalClose } = useContext(PostDetailContext);
  const webinarBtnText = useWebinarButtonText(postDetail, user_id);
  const { lang } = useContext(Language);
  const { splashData } = useContext(LoginUserData);
  const [modalOpen, setModalOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [fileToView, setFileToView] = useState({ type: null, media: null });
  const [isLikedUsersModal, setIsLikedUsersModal] = useState(false);
  const [width, setWidth] = useState("47%");
  const [comment, setComment] = useState("");
  const [replyingTo, setReplyingTo] = useState("");
  const [postComments, setPostComments] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  const [parentId, setParentId] = useState("");
  const [replyId, setReplyId] = useState("");
  const [commentReplies, setCommentReplies] = useState({});
  const [showReplies, setShowReplies] = useState({});
  const [loader, setLoader] = useState(false);
  const [postDropDown, setPostDropDown] = useState(false);
  const [_isOpen, setIsOpen] = useState(false);
  const [dropdownId, setDropDownId] = useState(null);
  const [reportModal, setReportModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [editPostInput, setEditPostInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inviteWebinar, setInviteWebinar] = useState(false);
  const [webinarType, setWebinarType] = useState(null);
  const [editWebinar, setEditWebinar] = useState(false);
  const [editPost, setEditPost] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [showPost, setShowPost] = useState(false);
  const [pollId, setPollId] = useState(null);
  const [modalOpenPoll, setModalOpenPoll] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth < 1200 ? "60%" : "47%");
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [isChrome, setIsChrome] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("chrome") > -1 && userAgent.indexOf("edge") === -1) {
      setIsChrome(true);
    }
  }, []);

  const openModal = (file, type) => {
    setFileToView({ ...fileToView, type: type, media: file });
    setPdfModalOpen(true);
  };

  const closeModal = () => {
    setPdfModalOpen(false);
    setFileToView(null);
  };

  const handleLike = useMutation({
    mutationFn: (overrideId) => {
      const pid = (typeof overrideId === "string" || typeof overrideId === "number")
        ? overrideId
        : (postDetail?.original_id || postDetail?.id);
      return likePostApi({ post_id: pid });
    },
    onError: (error) => toast.error(error.message),
    onMutate: () => {
    },
    onSuccess: (data) => {
      if (!data.status) toast.error(data.action);
    },
  });

  const handleSave = useMutation({
    mutationFn: (overrideId) => {
      const pid = (typeof overrideId === "string" || typeof overrideId === "number")
        ? overrideId
        : (postDetail?.original_id || postDetail?.id);
      return savePostApi({ post_id: pid });
    },
    onError: (error) => {
      updatePostDetail({
        ...postDetail,
        isSave: !postDetail?.isSave,
      });
      toast.error(error.message);
    },
    onMutate: () => {
      updatePostDetail({
        ...postDetail,
        isSave: !postDetail?.isSave,
      });
    },
    onSuccess: (data) => {
      if (!data.status) {
        updatePostDetail({
          ...postDetail,
          isSave: !postDetail?.isSave,
        });
        toast.error(data.action);
      } else {
        queryClient.invalidateQueries("feedData");
      }
    },
  });

  const handleReserveWebinar = useCallback(async () => {
    try {
      postDetail.isReserve = !postDetail.isReserve;
      updatePostDetail(postDetail);
      await reserveWebinarApi({ post_id: postDetail?.original_id || postDetail?.id });
    } catch (error) {
      console.error(error);
    }
  }, [postDetail]);

  const handleRepost = useMutation({
    mutationFn: (overrideId) => {
      const pid = (typeof overrideId === "string" || typeof overrideId === "number")
        ? overrideId
        : (postDetail?.original_id || postDetail?.id);
      return repostPostApi({ post_id: pid });
    },
    onError: (error) => {
      const isNowShare = !postDetail?.isShare;
      const currentShares = Number(postDetail?.shares_count ?? postDetail?.share_count ?? 0);
      updatePostDetail({
        ...postDetail,
        isShare: !isNowShare,
        shares_count: isNowShare ? Math.max(0, currentShares - 1) : currentShares + 1,
      });
      toast.error(error.message);
    },
    onMutate: () => {
      const isNowShare = !postDetail?.isShare;
      const currentShares = Number(postDetail?.shares_count ?? postDetail?.share_count ?? 0);
      updatePostDetail({
        ...postDetail,
        isShare: isNowShare,
        shares_count: isNowShare ? currentShares + 1 : Math.max(0, currentShares - 1),
      });
    },
    onSuccess: (data) => {
      if (!data.status) {
        toast.error(data.action);
      } else {
        queryClient.invalidateQueries("feedData");
      }
    },
  });

  const handleDeletePost = async () => {
    try {
      setIsLoading(true);
      const pid = postDetail?.original_id || postDetail?.id;
      const response = await axios.get(`${DeletePostApi}${pid}`, authorize());
      if (response.data.status) {
        setDeleteModal(false);
        onClose();
        toast.success(lang.post_deleted_successfully);
        queryClient.invalidateQueries("feedData");
      } else {
        toast.error(response.data.action);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditPost = async () => {
    setIsLoading(true);
    try {
      const editData = { caption: editPostInput, post_id: dropdownId };
      const response = await axios.post(EditPostApi, editData, authorize());
      if (response.data.status) {
        setEditModal(false);
        postDetail.caption = editPostInput;
        updatePostDetail(postDetail);
        toast.success(lang.post_updated_successfully);
      } else {
        toast.error(response.data.action);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleLikePost = useCallback(
    async (overrideId, reaction_type = "like") => {
      const pid = (typeof overrideId === "string" || typeof overrideId === "number")
        ? overrideId
        : (postDetail?.original_id || postDetail?.id);
      if (!pid || !postDetail) return;

      const wasLiked = Boolean(
        postDetail.isLike || postDetail.reaction || postDetail.user_reaction
      );
      const currentReaction = postDetail.reaction || postDetail.user_reaction;
      const isTogglingOff = Boolean(
        wasLiked &&
        currentReaction &&
        String(currentReaction).toLowerCase() === String(reaction_type).toLowerCase()
      );
      const nextIsLiked = !isTogglingOff;
      const nextReaction = isTogglingOff ? null : reaction_type;

      const currentCounts = postDetail.reaction_counts && typeof postDetail.reaction_counts === "object"
        ? { ...postDetail.reaction_counts }
        : {};
      if (currentReaction && currentCounts[currentReaction]) {
        currentCounts[currentReaction] = Math.max(
          0,
          Number(currentCounts[currentReaction] || 0) - 1
        );
        if (currentCounts[currentReaction] === 0) {
          delete currentCounts[currentReaction];
        }
      }
      if (nextReaction) {
        currentCounts[nextReaction] =
          (Number(currentCounts[nextReaction]) || 0) + 1;
      }

      let updatedImages = postDetail.like_users_images
        ? [...postDetail.like_users_images]
        : [];
      if (nextIsLiked && !wasLiked && user?.data?.image) {
        updatedImages = [
          user.data.image,
          ...updatedImages.filter((img) => img !== user.data.image),
        ];
      } else if (!nextIsLiked && wasLiked && user?.data?.image) {
        updatedImages = updatedImages.filter(
          (image) => image !== user?.data?.image
        );
      }

      const countDelta =
        nextIsLiked && !wasLiked
          ? 1
          : !nextIsLiked && wasLiked
          ? -1
          : 0;

      const totalLikesFromCounts = calculateTotalReactions(
        currentCounts,
        Math.max(0, Number(postDetail.likes_count || 0) + countDelta)
      );

      const updatedPost = {
        ...postDetail,
        isLike: nextIsLiked,
        reaction: nextReaction,
        reaction_counts: currentCounts,
        likes_count: totalLikesFromCounts,
        like_users_images: updatedImages,
      };

      updatePostDetail(updatedPost);

      try {
        await reactToPostApi({ post_id: pid, reaction_type });
      } catch (error) {
        toast.error(error.message);
      }
    },
    [postDetail, user?.data?.image, updatePostDetail]
  );

  const handleRepostClick = (overrideId) => {
    const isOwner = postDetail?.user?.id === user_id;
    const pid = overrideId || postDetail?.original_id || postDetail?.id;
    if (type !== "poll") {
      if (!isOwner) {
        handleRepost.mutate(pid);
      } else {
        setModalOpen(true);
      }
    } else {
      if (isOwner) {
        setModalOpen(true);
      } else {
        if (!postDetail.isShare) {
          setModalOpen(!modalOpen);
        } else {
          handleRepost.mutate(pid);
        }
      }
    }
  };

  const self_like_image = user?.data?.image;
  const isOwner = postDetail?.user?.id === user_id;
  const repostTitle = isOwner
    ? `${postDetail?.shares_count} ${lang?.repost}`
    : `${postDetail?.isShare ? lang?.reposted : lang?.repost}`;

  const handleGetComments = useCallback(
    async (post_id) => {
      setCommentLoading(true);
      const id = post_id || postDetail?.original_id || postDetail?.id;
      if (!id) {
        setCommentLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${GetCommentsApi}${id}?page=1`, authorize());
        if (response.data.status) {
          setPostComments(response?.data?.data);
        }
        setCommentLoading(false);
      } catch (error) {
        console.error(error);
      }
    },
    [postDetail?.original_id, postDetail?.id, user_id]
  );

  const handleGetReplies = useCallback(
    async (parentId) => {
      if (showReplies[parentId]) {
        setShowReplies((prev) => ({
          ...prev,
          [parentId]: false,
        }));
        return;
      }

      setLoader((prev) => ({ ...prev, [parentId]: true }));
      try {
        const response = await axios.get(`${GetRepliesApi}${parentId}`, authorize());
        if (response.data.status) {
          setCommentReplies((prev) => ({
            ...prev,
            [parentId]: response.data.data,
          }));
          setShowReplies((prev) => ({
            ...prev,
            [parentId]: true,
          }));
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoader((prev) => ({ ...prev, [parentId]: false }));
      }
    },
    [showReplies]
  );

  useEffect(() => {
    if (postDetail?.original_id || postDetail?.id) {
      handleGetComments();
    }
  }, [postDetail?.original_id, postDetail?.id, handleGetComments]);

  const closeBtn = (
    <button
      type="button"
      className="pdm-close-btn"
      aria-label="Close"
      onClick={() => {
        onClose();
        editWebinarTab(false);
        setSelectedPost(null);
      }}
    >
      <IoCloseSharp size={18} />
    </button>
  );

  const dropdownRef = useRef(null);

  const handleDotsClick = (e) => {
    e.stopPropagation();
    setPostDropDown((prev) => !prev);
    setDropDownId(postDetail?.original_id || postDetail?.id);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setPostDropDown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFollow = useCallback(async (id) => {
    try {
      const res = await axios.get(`${FollowApi}${id}`, authorize());
      if (res.data.status) {
        postDetail.user.follow = !postDetail.user.follow;
        updatePostDetail(postDetail);
      } else {
        console.log(res.data.error);
      }
    } catch (error) {
      console.error('Error following user:', error);
    } finally {
      setIsLoading(false);
    }
  }, [postDetail, user_id]);

  const handlePostSelect = (postDetail) => {
    setSelectedPost(postDetail);
  };

  const editWebinarTab = (edit) => {
    setEditWebinar(edit);
  };

  const editPostTab = (edit) => {
    setEditPost(edit);
  };

  const handlePollAnswer = async (post_id, answer) => {
    try {
      postDetail.id = post_id;
      postDetail.right = answer + 1;
      postDetail.votes_count = postDetail.votes_count + 1;
      updatePostDetail({ ...postDetail });
      const response = await axios.post(
        `${adminBaseURL}user/post/poll/answer/submit`,
        {
          post_id,
          answer: answer + 1,
        },
        authorize()
      );
      if (!response.data.status) {
        toast.error(response.data.action);
      } else {
        postDetail.percs = response.data.data;
        updatePostDetail({ ...postDetail });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const removePollAnswer = async (id) => {
    try {
      postDetail.id = id;
      postDetail.right = 0;
      postDetail.votes_count = postDetail.votes_count - 1;
      updatePostDetail({ ...postDetail });
      const response = await axios.get(
        `${adminBaseURL}user/post/poll/answer/remove/${id}`,
        authorize()
      );
      if (!response.data.status) {
        toast.error(response.data.action);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const toggleModal = useCallback((id) => {
    setPollId(id);
    setModalOpenPoll((prev) => !prev);
  }, []);

  const handlePostReport = useCallback(async (reportParam, categoryParam) => {
    const category =
      (typeof reportParam === "object" ? reportParam?.category : categoryParam) || "";
    const reportText =
      (typeof reportParam === "object" ? reportParam?.report : reportParam) || "";

    if (!category && !reportText?.trim()) {
      toast.error("Please enter a report");
      return;
    }
    setIsLoading(true);
    try {
      const reportData = {
        feature_id: dropdownId,
        user_id,
        category,
        report: reportText,
        type: "post",
      };
      const response = await axios.post(`${adminBaseURL}app/report`, reportData, authorize);
      if (response.data.status) {
        toast.success("Reported Successfully!");
        setReportModal(false);
      } else {
        toast.error(response.data.action);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [dropdownId, user_id]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const indicatorStyles = useMemo(
    () => ({
      background: "rgba(15, 23, 42, 0.25)",
      width: 20,
      height: 4,
      display: "inline-block",
      margin: "0 4px",
      borderRadius: "2px",
    }),
    []
  );
  return postDetail?.original_id ? (
    <>
      <Modal
        isOpen={isOpen}
        toggle={onClose}
        centered
        size={postDetail?.media?.length > 0 ? "xl" : "lg"}
        className={`post_detail_modal app-responsive-post-modal ${!postDetail?.media?.length ? "pdm-dialog-no-media" : ""}`}
        backdrop="static"
      >
        <style>
          {`
      /* ── Medical Radar theme — post detail lightbox ── */
      .app-responsive-post-modal,
      .app-responsive-post-modal.modal-dialog,
      .app-responsive-post-modal .modal-dialog,
      .modal-dialog.app-responsive-post-modal {
        max-width: 1120px !important;
        width: 92vw !important;
        margin: 1.5rem auto !important;
      }

      .app-responsive-post-modal.pdm-dialog-no-media,
      .app-responsive-post-modal.pdm-dialog-no-media.modal-dialog,
      .modal-dialog.app-responsive-post-modal.pdm-dialog-no-media {
        max-width: 580px !important;
        width: 90vw !important;
      }

      .app-responsive-post-modal .modal-content {
        border: 1px solid #E2E8F0 !important;
        border-radius: 24px !important;
        overflow: hidden !important;
        box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28), 0 2px 8px rgba(0, 0, 0, 0.04) !important;
        background: #F0F9FF !important;
      }

      /* ── Main Container (Desktop) ── */
      .pdm-main-container {
        display: flex !important;
        flex-direction: row !important;
        width: 100% !important;
        height: 88vh !important;
        max-height: 760px !important;
        min-height: 520px !important;
        border-radius: 24px !important;
        overflow: hidden !important;
        background: #F0F9FF !important;
      }

      .pdm-main-container.pdm-no-media {
        max-width: 580px !important;
        margin: 0 auto !important;
        height: auto !important;
        max-height: 88vh !important;
        min-height: auto !important;
      }

      /* ── Media Pane (Left Column Desktop) ── */
      .pdm-media-pane {
        flex: 1.35 !important;
        width: 58% !important;
        min-width: 480px !important;
        background: #F8FAFC !important;
        position: relative !important;
        overflow: hidden !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-right: 1px solid #E2E8F0 !important;
      }

      .pdm-media-pane .carousel-root,
      .pdm-media-pane .carousel,
      .pdm-media-pane .carousel .slider-wrapper,
      .pdm-media-pane .carousel .slider-wrapper .slider {
        height: 100% !important;
        width: 100% !important;
      }

      .pdm-carousel-slide {
        height: 100% !important;
        max-height: 760px !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 20px !important;
        box-sizing: border-box !important;
        background: #F8FAFC !important;
      }

      .pdm-carousel-slide img,
      .pdm-carousel-slide video {
        max-width: 100% !important;
        max-height: 100% !important;
        width: auto !important;
        height: auto !important;
        object-fit: contain !important;
        border-radius: 16px !important;
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04) !important;
      }

      /* ── Content Pane (Right Column Desktop) — Matches Medical Doodle Canvas ── */
      .pdm-content-pane {
        flex: 1 !important;
        width: 42% !important;
        min-width: 380px !important;
        height: 100% !important;
        display: flex !important;
        flex-direction: column !important;
        background: #F0F9FF !important;
        position: relative !important;
        overflow: hidden !important;
        border-left: 1px solid #E2E8F0 !important;
      }

      .pdm-main-container.pdm-no-media .pdm-content-pane {
        width: 100% !important;
        min-width: 0 !important;
        border-left: none !important;
      }

      .pdm-close-btn {
        position: absolute;
        top: 14px;
        left: 14px;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(226, 232, 240, 0.9);
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        color: #0F172A;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
        cursor: pointer;
        z-index: 9999;
        transition: all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
      }

      .pdm-close-btn:hover {
        background: #00BADA;
        border-color: #00BADA;
        color: #FFFFFF;
        transform: scale(1.08) rotate(90deg);
      }

      .pdm-carousel-arrow {
        top: 0;
        bottom: 0;
        margin: auto 0;
        position: absolute;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(226, 232, 240, 0.9);
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        color: #0F172A;
        box-shadow: 0 4px 14px rgba(15, 23, 42, 0.1);
        cursor: pointer;
        z-index: 1000;
        transition: all 0.2s ease;
      }

      .pdm-carousel-arrow:hover {
        background: #00BADA;
        border-color: #00BADA;
        color: #FFFFFF;
        transform: scale(1.06);
        box-shadow: 0 6px 18px rgba(0, 186, 218, 0.35);
      }

      .pdm-header-row {
        padding: 14px 18px;
        background: #FFFFFF;
        border-bottom: 1px solid #F1F5F9;
      }

      .pdm-bottom-fixed {
        background: #FFFFFF !important;
        border-top: 1px solid #F1F5F9 !important;
      }

      .pdm-bottom-fixed .mr-post-footer {
        background: #FFFFFF !important;
      }

      .pdm-username {
        font-size: 15px;
        line-height: 1.3;
        color: #0F172A;
        font-weight: 600 !important;
      }

      .pdm-timestamp {
        font-size: 12px;
        color: #64748B;
        margin: 1px 0 0 0;
      }

      .pdm-badge {
        font-size: 10px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 999px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
      }

      .pdm-case-study-btn {
        border: none;
        width: 100%;
        margin-top: 6px;
        padding: 10px 20px;
        border-radius: 999px;
        background: #0F172A;
        color: #FFFFFF;
        font-size: 13.5px;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.18);
        transition: all 0.2s ease;
      }

      .pdm-case-study-btn:hover {
        background: #1E293B;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(15, 23, 42, 0.25);
      }

      .pdm-webinar-chip {
        background: #F0F9FF;
        border: 1px solid #BAE6FD;
        border-radius: 16px;
      }

      .pdm-webinar-cta {
        border-radius: 999px !important;
        font-size: 14px;
        box-shadow: 0 4px 14px rgba(15, 23, 42, 0.16);
        transition: all 0.2s ease;
      }

      .pdm-webinar-cta:hover {
        transform: translateY(-1px);
      }

      .pdm-subtle-modal {
        border-radius: 20px;
        overflow: hidden;
        border: 1px solid #E2E8F0;
      }

      /* ── Medical doodle canvas (same pattern as the chat screen) ── */
      .pdm-comments-bg {
        background-color: #F0F9FF;
        background-image: url("data:image/svg+xml,%3Csvg width='280' height='280' viewBox='0 0 280 280' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%231DC1DD' stroke-opacity='0.24' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg transform='translate(35 35) rotate(12)' stroke-width='1.5'%3E%3Cpath d='M-11 0 C-6 -7 6 -7 11 0 C6 7 -6 7 -11 0 Z'/%3E%3Ccircle cx='0' cy='0' r='4' stroke-width='1.2'/%3E%3Ccircle cx='0' cy='0' r='1.8' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3C/g%3E%3Cg transform='translate(190 30) rotate(-15)' stroke-width='1.5'%3E%3Ccircle cx='-7' cy='0' r='5.5'/%3E%3Ccircle cx='7' cy='0' r='5.5'/%3E%3Cpath d='M-1.5 -1.5 C-0.5 -3.5 0.5 -3.5 1.5 -1.5'/%3E%3Cline x1='-12.5' y1='-1' x2='-16' y2='-5'/%3E%3Cline x1='12.5' y1='-1' x2='16' y2='-5'/%3E%3C/g%3E%3Cg transform='translate(115 25) rotate(-8)' stroke-width='1.4'%3E%3Crect x='-7' y='-10' width='14' height='20' rx='2'/%3E%3Cpath d='M-3 -6h6M-3 -6v5h5M-3 -3.5h4'/%3E%3Cline x1='-4' y1='2' x2='4' y2='2'/%3E%3Cline x1='-4' y1='2' x2='-4' y2='4'/%3E%3Cline x1='-4' y1='6' x2='4' y2='6'/%3E%3C/g%3E%3Cg transform='translate(75 20) rotate(15)' stroke-width='1.4'%3E%3Ccircle cx='0' cy='-4' r='5'/%3E%3Cline x1='0' y1='1' x2='0' y2='9'/%3E%3Cline x1='-4' y1='9' x2='4' y2='9'/%3E%3C/g%3E%3Cg transform='translate(255 70) rotate(32)' stroke-width='1.4'%3E%3Ccircle cx='0' cy='-7' r='5.5'/%3E%3Ccircle cx='0' cy='-7' r='2.5'/%3E%3Crect x='-2' y='-1.5' width='4' height='13' rx='1'/%3E%3C/g%3E%3Cg transform='translate(65 90) rotate(-25)' stroke-width='1.4'%3E%3Crect x='-4.5' y='-3' width='9' height='12' rx='2'/%3E%3Cpath d='M-2 -3 L0 -8 L2 -3 Z'/%3E%3Cpath d='M0 12 C-1.5 14 0 16 0 16 C0 16 1.5 14 0 12 Z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3C/g%3E%3Cg transform='translate(170 80) rotate(15)' stroke-width='1.4'%3E%3Cpath d='M0 -9 C3.5 -4.5 3.5 4.5 0 9 C-3.5 4.5 -3.5 -4.5 0 -9 Z'/%3E%3Cline x1='-11' y1='-5' x2='11' y2='0'/%3E%3Cline x1='-11' y1='5' x2='11' y2='0'/%3E%3C/g%3E%3Cg transform='translate(115 85) rotate(-30)' stroke-width='1.4'%3E%3Cpath d='M-8 -2 C-3 -7 3 -7 8 -2 C4 -4.5 -4 -4.5 -8 -2 Z' fill='%231DC1DD' fill-opacity='0.24'/%3E%3Ccircle cx='0' cy='-2' r='7' stroke-dasharray='2 2'/%3E%3C/g%3E%3Cg transform='translate(20 125) rotate(-20)' stroke-width='1.4'%3E%3Ccircle cx='0' cy='0' r='7.5'/%3E%3Ccircle cx='0' cy='0' r='3.5'/%3E%3Cline x1='-10' y1='0' x2='-7.5' y2='0'/%3E%3Cline x1='7.5' y1='0' x2='10' y2='0'/%3E%3Cline x1='0' y1='-10' x2='0' y2='-7.5'/%3E%3Cline x1='0' y1='7.5' x2='0' y2='10'/%3E%3C/g%3E%3Cg transform='translate(220 125) rotate(-40)' stroke-width='1.4'%3E%3Ccircle cx='0' cy='-7' r='5'/%3E%3Ccircle cx='0' cy='-7' r='2'/%3E%3Crect x='-2' y='-1.5' width='4' height='12' rx='1'/%3E%3C/g%3E%3Cg transform='translate(70 145) rotate(-45)' stroke-width='1.4'%3E%3Cpath d='M0 -8 C3 -4 3 4 0 8 C-3 4 -3 -4 0 -8 Z'/%3E%3Cline x1='-10' y1='-4' x2='10' y2='0'/%3E%3Cline x1='-10' y1='4' x2='10' y2='0'/%3E%3C/g%3E%3Cg transform='translate(140 155) rotate(-10)' stroke-width='1.5'%3E%3Cpath d='M-11 0 C-6 -7 6 -7 11 0 C6 7 -6 7 -11 0 Z'/%3E%3Ccircle cx='0' cy='0' r='4.5' stroke-width='1.2'/%3E%3Ccircle cx='0' cy='0' r='2' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3C/g%3E%3Cg transform='translate(15 185) rotate(10)' stroke-width='1.4'%3E%3Crect x='-6' y='-9' width='12' height='18' rx='2'/%3E%3Cpath d='M-2.5 -5.5h5M-2.5 -5.5v4.5h4M-2.5 -3.5h3.5'/%3E%3Cline x1='-3' y1='2' x2='3' y2='2'/%3E%3Cline x1='-3' y1='5' x2='3' y2='5'/%3E%3C/g%3E%3Cg transform='translate(260 175) rotate(40)' stroke-width='1.4'%3E%3Cpath d='M-8 -2 C-3 -7 3 -7 8 -2 C4 -4.5 -4 -4.5 -8 -2 Z' fill='%231DC1DD' fill-opacity='0.24'/%3E%3Ccircle cx='0' cy='-2' r='7' stroke-dasharray='2 2'/%3E%3C/g%3E%3Cg transform='translate(80 205) rotate(22)' stroke-width='1.5'%3E%3Crect x='-12' y='-5' width='10' height='9' rx='2'/%3E%3Crect x='2' y='-5' width='10' height='9' rx='2'/%3E%3Cpath d='M-2 -2 C0 -3.5 0 -3.5 2 -2'/%3E%3Cline x1='-12' y1='-1' x2='-15.5' y2='-5'/%3E%3Cline x1='12' y1='-1' x2='15.5' y2='-5'/%3E%3C/g%3E%3Cg transform='translate(140 215) rotate(15)' stroke-width='1.4'%3E%3Ccircle cx='0' cy='0' r='7'/%3E%3Ccircle cx='0' cy='0' r='3'/%3E%3Cline x1='-9' y1='0' x2='-7' y2='0'/%3E%3Cline x1='7' y1='0' x2='9' y2='0'/%3E%3Cline x1='0' y1='-9' x2='0' y2='-7'/%3E%3Cline x1='0' y1='7' x2='0' y2='9'/%3E%3C/g%3E%3Cg transform='translate(200 215) rotate(-35)' stroke-width='1.4'%3E%3Crect x='-4.5' y='-3' width='9' height='12' rx='2'/%3E%3Cpath d='M-2 -3 L0 -8 L2 -3 Z'/%3E%3Cpath d='M0 12 C-1.5 14 0 16 0 16 C0 16 1.5 14 0 12 Z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3C/g%3E%3Cg transform='translate(255 245) rotate(12)' stroke-width='1.4'%3E%3Crect x='-7' y='-10' width='14' height='20' rx='2'/%3E%3Cpath d='M-3 -6h6M-3 -6v5h5M-3 -3.5h4'/%3E%3Cline x1='-4' y1='2' x2='4' y2='2'/%3E%3Cline x1='-4' y1='6' x2='4' y2='6'/%3E%3C/g%3E%3Cg transform='translate(25 265) rotate(-45)' stroke-width='1.4'%3E%3Ccircle cx='0' cy='-7' r='5.5'/%3E%3Ccircle cx='0' cy='-7' r='2.5'/%3E%3Crect x='-2' y='-1.5' width='4' height='13' rx='1'/%3E%3C/g%3E%3Cg transform='translate(170 270) rotate(-15)' stroke-width='1.5'%3E%3Cpath d='M-10 0 C-5 -6 5 -6 10 0 C5 6 -5 6 -10 0 Z'/%3E%3Ccircle cx='0' cy='0' r='4' stroke-width='1.2'/%3E%3Ccircle cx='0' cy='0' r='1.7' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3C/g%3E%3Cg transform='translate(100 275) rotate(20)' stroke-width='1.4'%3E%3Crect x='-4' y='-3' width='8' height='11' rx='2'/%3E%3Cpath d='M-2 -3 L0 -7 L2 -3 Z'/%3E%3Cpath d='M0 11 C-1.5 13 0 15 0 15 C0 15 1.5 13 0 11 Z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3C/g%3E%3Cpath transform='translate(145 45) rotate(10)' d='M0 -5l1.5 3.5 3.5 1.5-3.5 1.5-1.5 3.5-1.5-3.5-3.5-1.5 3.5-1.5z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3Cpath transform='translate(210 165) rotate(-35)' d='M0 -5l1.5 3.5 3.5 1.5-3.5 1.5-1.5 3.5-1.5-3.5-3.5-1.5 3.5-1.5z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3Cpath transform='translate(75 60) rotate(20)' d='M0 -5l1.5 3.5 3.5 1.5-3.5 1.5-1.5 3.5-1.5-3.5-3.5-1.5 3.5-1.5z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3Cpath transform='translate(20 50) rotate(-15)' d='M0 -4l1.2 2.8 2.8 1.2-2.8 1.2-1.2 2.8-1.2-2.8-2.8-1.2 2.8-1.2z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3Cpath transform='translate(265 110) rotate(25)' d='M0 -4l1.2 2.8 2.8 1.2-2.8 1.2-1.2 2.8-1.2-2.8-2.8-1.2 2.8-1.2z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3Cpath transform='translate(125 185) rotate(-25)' d='M0 -4l1.2 2.8 2.8 1.2-2.8 1.2-1.2 2.8-1.2-2.8-2.8-1.2 2.8-1.2z' fill='%231DC1DD' fill-opacity='0.24' stroke='none'/%3E%3Ccircle cx='60' cy='15' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='235' cy='15' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='155' cy='20' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='15' cy='75' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='215' cy='55' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='270' cy='35' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='40' cy='105' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='160' cy='120' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='95' cy='125' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='250' cy='145' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='180' cy='145' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='15' cy='155' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='105' cy='165' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='45' cy='170' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='235' cy='195' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='165' cy='190' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='115' cy='235' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='45' cy='225' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='15' cy='230' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='215' cy='260' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='135' cy='255' r='2.5' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3Ccircle cx='65' cy='250' r='2' fill='%231DC1DD' fill-opacity='0.28' stroke='none'/%3E%3C/g%3E%3C/svg%3E");
        background-repeat: repeat;
        background-size: 280px 280px;
      }

      .modal-content-scroll::-webkit-scrollbar {
        display: none;
      }

      /* ═══════════════════════════════════════════════════════════════
         RESPONSIVE (Screen width < 992px: Tablets & Mobile Screens)
         ═══════════════════════════════════════════════════════════════ */
      @media (max-width: 991.98px) {
        .app-responsive-post-modal,
        .app-responsive-post-modal.modal-dialog,
        .app-responsive-post-modal .modal-dialog,
        .modal-dialog.app-responsive-post-modal {
          max-width: 95vw !important;
          width: 95vw !important;
          min-width: 0 !important;
          margin: 0.5rem auto !important;
          height: calc(100vh - 1rem) !important;
          display: flex !important;
          align-items: center !important;
        }

        .app-responsive-post-modal .modal-content {
          height: 94vh !important;
          max-height: 94vh !important;
          border-radius: 20px !important;
          width: 100% !important;
        }

        .pdm-main-container {
          flex-direction: column !important;
          height: 100% !important;
          max-height: 100% !important;
          min-height: 0 !important;
          border-radius: 20px !important;
        }

        .pdm-media-pane {
          width: 100% !important;
          min-width: 0 !important;
          height: 28vh !important;
          min-height: 140px !important;
          max-height: 30vh !important;
          flex: none !important;
          flex-shrink: 0 !important;
          border-radius: 20px 20px 0 0 !important;
        }

        .pdm-carousel-slide {
          height: 28vh !important;
          max-height: 30vh !important;
          padding: 0 !important;
        }

        .pdm-content-pane {
          width: 100% !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
          min-height: 0 !important;
          height: 100% !important;
          display: flex !important;
          flex-direction: column !important;
          border-left: none !important;
          border-top: 1px solid #F1F5F9 !important;
          border-radius: 0 0 20px 20px !important;
        }

        .app-mobile-actions {
          display: grid !important;
          grid-template-columns: repeat(4, 1fr) !important;
          gap: 0.25rem !important;
          text-align: center !important;
          padding: 0.5rem !important;
          background: white !important;
          border-top: 1px solid #F1F5F9 !important;
          margin: 0 !important;
        }

        .app-mobile-action-item {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          padding: 0.35rem 0.15rem !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: background-color 0.2s ease !important;
        }

        .app-mobile-action-item:hover {
          background-color: #f8f9fa !important;
        }

        .app-mobile-action-text {
          font-size: 0.72rem !important;
          margin-top: 0.2rem !important;
          white-space: nowrap !important;
        }
      }

      /* ═══════════════════════════════════════════════════════════════
         MOBILE PHONES (< 768px)
         ═══════════════════════════════════════════════════════════════ */
      @media (max-width: 767.98px) {
        .app-responsive-post-modal,
        .app-responsive-post-modal.modal-dialog,
        .app-responsive-post-modal .modal-dialog,
        .modal-dialog.app-responsive-post-modal {
          max-width: 100vw !important;
          width: 100vw !important;
          margin: 0 !important;
          height: 100vh !important;
        }

        .app-responsive-post-modal .modal-content {
          height: 100vh !important;
          max-height: 100vh !important;
          border-radius: 0 !important;
        }

        .pdm-main-container {
          border-radius: 0 !important;
        }

        .pdm-media-pane {
          height: 22vh !important;
          min-height: 120px !important;
          max-height: 24vh !important;
          border-radius: 0 !important;
        }

        .pdm-carousel-slide {
          height: 22vh !important;
          max-height: 24vh !important;
          padding: 0 !important;
        }

        .pdm-content-pane {
          border-radius: 0 !important;
          flex: 1 1 auto !important;
          height: auto !important;
          min-height: 0 !important;
        }

        .pdm-header-row {
          padding: 8px 12px !important;
        }

        .pdm-username {
          font-size: 13.5px !important;
        }

        .pdm-timestamp {
          font-size: 11px !important;
        }

        .pdm-caption-area {
          padding: 6px 12px !important;
          max-height: 75px !important;
          overflow-y: auto !important;
        }

        .modal-content-scroll.pdm-comments-bg {
          flex: 1 1 0% !important;
          min-height: 180px !important;
          height: auto !important;
        }

        .pdm-bottom-fixed .mr-social-proof-bar {
          padding: 4px 10px !important;
        }

        .pdm-bottom-fixed .mr-actions-row {
          padding: 2px 4px !important;
        }

        .app-mobile-action-text {
          font-size: 0.68rem !important;
        }
      }
    `}
        </style>

        <div
          className={`pdm-main-container ${!postDetail?.media?.length ? "pdm-no-media" : ""}`}
        >
          {postDetail?.media?.length > 0 && (
            <div className="pdm-media-pane">
              {closeBtn}
              <PostMediaGallery
                media={postDetail.media}
                type={postDetail.type}
                isModal={true}
              />
            </div>
          )}

          <div className="pdm-content-pane">
            {/* ── TOP STICKY SECTION: Author Header ONLY ── */}
            <div style={{ flexShrink: 0, borderBottom: "1px solid #F1F5F9", background: "#FFFFFF", zIndex: 5 }}>
              <div className="pdm-header-row d-flex align-items-center justify-content-between">
                <div className="d-flex gap-3 align-items-center" style={{ marginLeft: !postDetail?.media?.length && "53px" }}>
                  {!postDetail?.media?.length && closeBtn}
                  <ProfileAvatar
                    src={postDetail?.user?.image}
                    size={44}
                    variant="cyan"
                    alt={postDetail?.user?.name || "Author"}
                    className="cursor"
                    onClick={() => { postModalClose(); navigate(`/profile/${postDetail?.user?.user_name || postDetail?.user?.id}`); }}
                  />
                  <div className="align-self-center">
                    <h1
                      className="pdm-username roboto-bold hover-blue mb-0 text-ellips-162px cursor"
                      style={{ fontWeight: 600 }}
                      onClick={() => {
                        postModalClose();
                        navigate(`/profile/${postDetail?.user?.user_name || postDetail?.user?.id}`);
                      }}
                    >
                      {postDetail?.user?.name}
                    </h1>
                    <p className="pdm-timestamp roboto-regular mb-0">
                      {lang.posted} <UnixToRelative unixTimestamp={postDetail?.time} />
                    </p>
                  </div>
                </div>
                <div className="position-relative" ref={dropdownRef}>
                  <button
                    type="button"
                    className={`mr-post-dots-btn dots-button ${postDropDown ? "active" : ""}`}
                    onClick={handleDotsClick}
                    aria-label="Post options"
                  >
                    <BsThreeDots size={18} />
                  </button>
                  {postDropDown && (
                    <div isOpen={postDropDown}>
                      <PostHeaderDropdown
                        postDetails={postDetail}
                        postDropDown={postDropDown}
                        setPostDropDown={setPostDropDown}
                        dropDownId={dropdownId}
                        type={postDetail.type}
                        isSave={postDetail.isSave}
                        isShare={postDetail?.isShare}
                        shares_count={postDetail.shares_count}
                        isFollow={postDetail.user.follow}
                        isOwner={isOwner}
                        user_id={user_id}
                        lang={lang}
                        handleSave={handleSave.mutate}
                        handleRepost={handleRepost.mutate}
                        handleFollow={handleFollow}
                        setReportModal={setReportModal}
                        setEditModal={setEditModal}
                        setDeleteModal={setDeleteModal}
                        setShowPost={setShowPost}
                        editWebinarTab={editWebinarTab}
                        editPostTab={editPostTab}
                        setEditPost={setEditPost}
                        editPost={editPost}
                        handlePostSelect={handlePostSelect}
                        setInviteWebinar={setInviteWebinar}
                        setWebinarType={setWebinarType}
                        setShareModal={setShareModal}
                        setIsOpen={setIsOpen}
                        isOpen={_isOpen}
                        toggleRepostModal={() => setModalOpen(!modalOpen)}
                        from="postModal"
                        setEditPostInput={setEditPostInput}
                        closeDetailModal={onClose}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── MIDDLE SCROLLABLE SECTION: Caption, Polls, Case Study & Comments ── */}
            <div
              className="flex-grow-1 modal-content-scroll pdm-comments-bg"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {(postDetail?.caption || postDetail?.title || postDetail?.type === "poll") && (
                <div
                  className={`p-3 pdm-caption-area ${postDetail?.type === "webinar" || postDetail.type === "clinical-image"
                    ? null
                    : ""
                    } ${postDetail?.type === "poll" && "scroll-hide"}`}
                  style={{
                    background: "#FFFFFF",
                    borderBottom: "1px solid #F1F5F9",
                  }}
                >
                  {postDetail?.type === "webinar" || postDetail?.type === "clinical-image" ? (
                    <div className="p-1">
                      <h4 className="roboto-bold mb-1" style={{ color: "#0F172A", fontSize: "17px", fontWeight: 600 }}>
                        {postDetail?.title}
                      </h4>
                      <ReadMore text={postDetail?.caption} />
                    </div>
                  ) : (
                    postDetail.type !== "poll" && (
                      <div className="scroll-hide">
                        <ReadMore text={postDetail?.caption} />
                      </div>
                    )
                  )}
                  {postDetail.type === "poll" && (
                    <>
                      <h3 className="roboto-bold" style={{ color: "#0F172A", fontSize: "18px", fontWeight: 600 }}>
                        {postDetail.title}
                      </h3>
                      {postDetail.right === 0 && user_id !== postDetail.user.id ? (
                        <PollOptionsView
                          value={postDetail}
                          handlePollAnswer={handlePollAnswer}
                          toggleModal={toggleModal}
                        />
                      ) : (
                        <PollResultsView
                          value={postDetail}
                          toggleModal={toggleModal}
                          removePollAnswer={removePollAnswer}
                        />
                      )}
                    </>
                  )}
                </div>
              )}

              {postDetail?.type === "clinical-image" && postDetail?.pdf && (
                <div style={{ background: "#FFFFFF", paddingBottom: "12px", borderBottom: "1px solid #F1F5F9" }}>
                  <div className="px-3">
                    <button
                      type="button"
                      className="pdm-case-study-btn roboto-bold"
                      style={{ fontWeight: 600 }}
                      onClick={() => openModal(postDetail?.pdf, "pdf")}
                    >
                      {lang?.view_Case_Study}
                    </button>
                  </div>
                  <ClinicalPoll
                    clinicalId={postDetail?.original_id}
                    onClose={onClose}
                    customHeight={postDetail?.likes_count > 0 ? "customHeight" : undefined}
                  />
                </div>
              )}

              {postDetail?.type !== "webinar" && (
                <CommentList
                  postComments={postComments}
                  setPostComments={setPostComments}
                  handleGetComments={handleGetComments}
                  handleGetReplies={handleGetReplies}
                  setCommentReplies={setCommentReplies}
                  loader={loader}
                  commentReplies={commentReplies}
                  commentLoading={commentLoading}
                  setParentId={setParentId}
                  setReplyId={setReplyId}
                  parentId={parentId}
                  setReplyingTo={setReplyingTo}
                  setShowReplies={setShowReplies}
                  showReplies={showReplies}
                  captions={postDetail?.caption}
                  editWebinarTab={editWebinarTab}
                  setSelectedPost={setSelectedPost}
                  onClose={onClose}
                  type={postDetail?.type}
                  setSelectedImage={setSelectedImage}
                  selectedImage={selectedImage}
                />
              )}
            </div>

            {/* ── BOTTOM STICKY SECTION: PostFooter & Comment Input ── */}
            <div className="pdm-bottom-fixed" style={{ flexShrink: 0, borderTop: "1px solid #F1F5F9", background: "#FFFFFF", zIndex: 5 }}>
              {postDetail?.type !== "webinar" && (
                <PostFooter
                  likes_count={postDetail?.likes_count}
                  setPostId={() => { }}
                  original_id={postDetail?.original_id || postDetail?.id}
                  handleLikeUsers={() => setIsLikedUsersModal(true)}
                  like_users_images={postDetail?.like_users_images}
                  handleLike={(pid, rType) => handleLikePost(pid, rType)}
                  isLike={Boolean(postDetail?.isLike || postDetail?.reaction || postDetail?.user_reaction)}
                  handleGetComments={handleGetComments}
                  setPostModal={() => { }}
                  comments_count={postDetail?.comments_count}
                  handleRepost={(pid) => handleRepostClick(pid)}
                  isShare={postDetail?.isShare}
                  isSave={postDetail?.isSave}
                  handleSave={(pid) => handleSave.mutate(pid || postDetail?.original_id || postDetail?.id)}
                  shares_count={postDetail?.shares_count ?? postDetail?.share_count ?? postDetail?.reposts_count ?? postDetail?.shares}
                  type={postDetail?.type}
                  value={postDetail}
                  refetch={() => queryClient.invalidateQueries(["homePosts"])}
                  pollData={postDetail}
                />
              )}

              {postDetail?.type === "webinar" ? (
                <>
                  <Row className="px-3 my-2">
                    <Col className="pdm-webinar-chip d-flex align-self-center gap-3 mb-2 p-3 mx-2">
                      <div className="d-flex gap-2 align-items-center">
                        <GoClock size={15} color="#0284C7" />
                        <small className="mb-0 roboto-medium" style={{ color: "#0F172A" }}>
                          {postDetail?.schedule_time}
                        </small>
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <IoCalendarOutline size={15} color="#0284C7" />
                        <small className="mb-0 roboto-medium" style={{ color: "#0F172A" }}>
                          {formatDate(postDetail?.schedule_date)}
                        </small>
                      </div>
                    </Col>
                    <WebinarInvited webinarId={postDetail?.original_id} />
                  </Row>
                  <Row className="px-3 my-2" style={{ position: "sticky", bottom: "8px", backgroundColor: "white" }}>
                    <Col className="align-self-center">
                      <button
                        className={`pdm-webinar-cta px-4 py-2 fw-bold w-100 roboto-bold ${postDetail?.status === 2 && !postDetail?.isReserve
                          ? "bg-white border text-danger"
                          : "border-0 text-white"
                          }`}
                        style={
                          postDetail?.status === 2 && !postDetail?.isReserve
                            ? { borderColor: "#EF4444", fontWeight: 600 }
                            : { background: "#0F172A", fontWeight: 600 }
                        }
                        onClick={() => {
                          if (postDetail?.user.id === splashData?.user?.id) {
                            if (postDetail?.status === 0) return;
                            if (postDetail?.status === 2) return toast.info(lang.webinar_ended);
                            window.open(
                              postDetail?.isHost
                                ? postDetail?.meeting_host_url
                                : postDetail?.meeting_url,
                              "_blank"
                            );
                          } else {
                            if (postDetail?.status === 0) return handleReserveWebinar();
                            if (postDetail?.status === 1) {
                              if (postDetail?.isReserve) {
                                window.open(
                                  postDetail?.meeting_url || postDetail?.meeting_host_url,
                                  "_blank"
                                );
                              } else {
                                return handleReserveWebinar();
                              }
                            } else {
                              return toast.info(lang.webinar_is_ended);
                            }
                          }
                        }}
                      >
                        {webinarBtnText}
                      </button>
                    </Col>
                  </Row>
                </>
              ) : null}

              {postDetail?.type !== "webinar" && (
                <AddComment
                  postId={postDetail?.original_id}
                  setSelectedImage={setSelectedImage}
                  selectedImage={selectedImage}
                  setParentId={setParentId}
                  replyId={replyId}
                  handleGetReplies={handleGetReplies}
                  parentId={parentId}
                  comment={comment}
                  setComment={setComment}
                  replyingTo={replyingTo}
                  setReplyingTo={setReplyingTo}
                  handleGetComments={handleGetComments}
                  commentLoading={commentLoading}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
      {isLikedUsersModal && (
        <UsersLikedPostModal
          isOpen={isLikedUsersModal}
          onClose={() => setIsLikedUsersModal(false)}
          postId={postDetail?.original_id}
        />
      )}
      {modalOpen && (
        <RepostUserModal
          toggleModal={() => setModalOpen(!modalOpen)}
          modal={modalOpen}
          postId={postDetail.original_id}
        />
      )}
      {pdfModalOpen && (
        <Modal
          isOpen={pdfModalOpen}
          centered
          toggle={closeModal}
          size={isFullScreen ? "lg" : "lg"}
          className={isFullScreen ? "fullscreen-modal" : ""}
          contentClassName={isFullScreen ? "" : "pdm-subtle-modal"}
          style={isFullScreen ? { maxWidth: "100vw", maxHeight: "100vh", margin: 0 } : { maxHeight: "" }}
        >
          <ModalBody className="modal-body-view" style={{ maxHeight: "90vh", overflowY: "auto" }}>
            {fileToView && fileToView?.type === "pdf" && (
              <div
                className={`position-relative custom_pdf_viewer ${isFullScreen ? "full-screen" : ""}`}
                style={{ transition: "all 0.3s ease-in-out" }}
              >
                <div className="position-relative custom_pdf_viewer">
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: isFullScreen ? "46px" : "40px",
                      background: "white",
                      zIndex: 1000,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "0 10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h4
                        className="roboto-bold"
                        style={{
                          margin: 0,
                          padding: 0,
                          color: "#0F172A",
                          flexGrow: 1,
                          textAlign: "center",
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        {lang?.view_Case_Study || "Case Study PDF"}
                      </h4>
                    </div>
                    <hr style={{ borderColor: "#E2E8F0" }} />
                  </div>
                  <iframe
                    title="PDF Viewer"
                    src={`${_imagesURL + fileToView?.media}#toolbar=0&navpanes=0&scrollbar=0&view=FitH&messages=0&print=0&download=0`}
                    width="100%"
                    height="500px"
                    className={isChrome ? "mt-5" : ""}
                    style={{ border: "none" }}
                  />
                  <button
                    type="button"
                    title={isFullScreen ? "Exit full screen" : "Full Screen"}
                    onClick={toggleFullScreen}
                    className="pdm-close-btn position-absolute cursor"
                    style={{ top: "6px", right: "10px", left: "auto" }}
                  >
                    {isFullScreen ? <IoCloseSharp size={16} /> : <GoScreenFull size={15} />}
                  </button>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered zIndex={9999} contentClassName="pdm-subtle-modal" style={{ maxHeight: "50vh" }}>
        <ModalBody style={{ maxHeight: "50vh", overflowY: "auto" }}>
          <div className="pr-62px">
            <h2 className="text-blue fs-21 fs-md-16 roboto-bold" style={{ fontWeight: 600 }}>{lang?.do_want_delete_post}</h2>
            <p className="fs-16 fs-md-15 roboto-regular">{lang?.after_deleting_post_see_post}</p>
          </div>
          <hr />
          <div className="d-flex justify-content-end gap-3">
            <button
              className="manue-hover text-dark border-1 border rounded w-100 py-2 fs-md-14"
              onClick={() => setDeleteModal(false)}
            >
              {lang?.cancel}
            </button>
            <button
              className="btn-red border-0 rounded w-100 py-2 fs-md-14"
              onClick={handleDeletePost}
            >
              {isLoading ? <Spinner size={"sm"} /> : lang?.yes_delete}
            </button>
          </div>
        </ModalBody>
      </Modal>
      {reportModal && (
        <ReportModal
          isOpen={reportModal}
          toggle={setReportModal}
          handleReport={handlePostReport}
          isLoading={isLoading}
          heading={lang.report_post}
        />
      )}
      {inviteWebinar && (
        <InviteWebinarPopup
          isOpen={inviteWebinar}
          webinarId={postDetail?.original_id}
          toggleModal={() => {
            setInviteWebinar(!inviteWebinar);
            setWebinarType(null);
          }}
          type={webinarType}
        />
      )}
      {shareModal && (
        <ShareModal
          isOpen={shareModal}
          toggle={() => setShareModal(!shareModal)}
          type={postDetail.type}
          postId={postDetail.original_id}
        />
      )}
      {modalOpen && (
        <RepostUserModal
          toggleModal={() => setModalOpen(!modalOpen)}
          modal={modalOpen}
          postId={postDetail?.original_id}
        />
      )}
      {showPost && (
        <PostForm
          selectedPost={selectedPost}
          editWebinar={editWebinar}
          handlePostSelect={handlePostSelect}
          setEditWebinar={setEditWebinar}
          editPost={editPost}
          setEditPost={setEditPost}
          showPost={showPost}
          setShowPost={setShowPost}
          updatePost={(id, newCaption) => {
            if (postDetail) {
              postDetail.caption = newCaption;
              updatePostDetail({ ...postDetail, caption: newCaption });
            }
          }}
          refetch={() => queryClient.invalidateQueries(['feedData', selectedPost])}
        />
      )}
    </>
  ) : null;
}

export function UsersLikedPostModal({ isOpen, onClose, postId }) {
  const navigate = useNavigate();
  const { lang } = useContext(Language);
  const { postModalClose } = useContext(PostDetailContext);

  const [page, setPage] = useState(1);

  const { data, isLoading, isError, error, refetch } = useQuery(
    ["usersLikedPostApi", postId, page],
    () => usersLikedPostApi({ post_id: postId, page })
  );

  if (isError) {
    toast.error(error.message);
  }

  useEffect(() => {
    refetch();
  }, [postId, page]);

  return (
    <LikeUsersModal
      isOpen={isOpen}
      toggleLikesModal={onClose}
      likeSpinner={isLoading}
      likeUsers={data?.data}
      handleNewLikeUsers={() => setPage(page + 1)}
    />
  );
}